import { History } from 'history'
import Cookies from 'js-cookie'
import { match, matchPath } from 'react-router-dom'

import {
   ACCESS_DENIED_ROUTE_PATH,
   ACTIVITY_LOGS_ROUTE_PATH,
   ADMIN_ROUTE_PATH,
   ADMIN_ROUTE_SUFFIX,
   ADMIN_TEMPLATE_PIPELINES_ROUTE_SUFFIX,
   ADVANCED_ANALYTICS_DASHBOARDS_ROUTE_PATH,
   AGENT_ALLOCATION_GROUPS_ROUTE_PATH,
   AGENT_SCHEDULES_PATH_SUFFIX,
   ALL_AUTOMATION_WORKFLOWS_ROUTE_PATH,
   ANALYTICS_BUILDER_ENTITY,
   ANALYTICS_BUILDER_ROUTE_PATH,
   ANALYTICS_COPILOT_IN_PIPELINE_SIDEBAR_PATH,
   ANALYTICS_COPILOT_PATH,
   APPLICATION_PREFIX,
   AUTOMATION_WORKFLOWS_EXECUTION_LOGS_ROUTE_PATH,
   AW_EXECUTION_LOGS_SUFFIX,
   BOARD_ROUTE_PATH,
   BOARD_SUFFIX,
   CALLS_ROUTE_PATH,
   CONTACT_BOARD_PATH,
   CUSTOM_OBJECT_PREFIX,
   DASHBOARD_GRAPH_DETAILED_VIEW_ROUTE_PATH,
   DASHBOARDS_IN_PIPELINE_SIDEBAR_PATH,
   DASHBOARDS_PATH,
   DEAL_PREFIX,
   DISTRIBUTION_RULES_ROUTE_PATH,
   DOCUMENT_TEMPLATES_ROUTE_SUFFIX,
   DOWNLOADS_ROUTE_PATH,
   DOWNLOADS_SUFFIX,
   GRAPH_DETAILED_VIEW_ROUTE_PATH,
   GRAPH_SUFFIX,
   HOME_BOARD_ROUTE_PATH,
   HOME_ROUTE_PATH,
   KNOWLARITY_PLUGIN_ACCOUNTS_ROUTE_PATH,
   LEAD_PREFIX,
   LIST_ROUTE_PATH,
   LIST_SUFFIX,
   NO_BOARDS_ROUTE_PATH,
   PARAMETERS_STORE_PATH,
   PINNED_PIPELINE_ITEMS_ROUTE_PATH,
   PIPELINE_ENTITY,
   PIPELINE_SETTINGS_PATH,
   PLUGIN_ACCOUNT_DETAILED_VIEW_SUFFIX,
   PLUGINS_ROUTE_PATH,
   RD_EXECUTION_LOGS_ROUTE_PATH,
   RECORD_PREFIX,
   REMINDERS_PATH,
   ROLES_ROUTE_PATH,
   SALES_PIPELINE_SUFFIX,
   SCORING_RECALCULATION_LOGS_ROUTE_SUFFIX,
   SMARTFLO_PLUGIN_ACCOUNTS_ROUTE_PATH,
   TEMPLATES_SUFFIX,
   USER_GROUPS_ROUTE_PATH,
   USERS_ROUTE_PATH,
   LEGACY_APPLICATIONS_SUFFIX,
   LEGACY_APPLICATION_DETAILED_VIEW_SUFFIX
} from '@flowwai-frontend/bps-officer-web/common/data-access'
import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import { CRMItemTypeEnum } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'
import { openLinkInNewTab } from '@flowwai-frontend/shared/utils/common'

import {
   ACTIVITY_LOGS,
   ADVANCED_ANALYTICS_DASHBOARDS,
   AGENT_ALLOCATION_GROUPS,
   ALL_AUTOMATION_WORKFLOWS,
   ALL_REMINDERS,
   ANALYTICS_BUILDER,
   ANALYTICS_COPILOT,
   AUTOMATION_WORKFLOWS_EXECUTION_LOGS,
   CALLS,
   DASHBOARDS,
   DISTRIBUTION_RULES,
   DOWNLOADS,
   EXECUTION_LOGS,
   HOME_BOARD,
   PARAMETERS_STORE,
   PINNED,
   ROLES,
   USER_GROUPS,
   USERS
} from '../constants/DefaultBoardConstants'

export const getBoardIdFromDefaultBoards = (
   pathName: string
): string | null => {
   const isWorkflowsPath = matchPath(pathName, {
      path: ALL_AUTOMATION_WORKFLOWS_ROUTE_PATH
   })

   const isWorkflowsExecutionLogsPath = matchPath(pathName, {
      path: AUTOMATION_WORKFLOWS_EXECUTION_LOGS_ROUTE_PATH
   })

   const isAnalyticsPath = matchPath(pathName, {
      path: ANALYTICS_BUILDER_ROUTE_PATH
   })
   const isAllRemindersPath = matchPath(pathName, {
      path: REMINDERS_PATH
   })
   const isContactBoardPath = matchPath(pathName, {
      path: CONTACT_BOARD_PATH
   })

   const isParameterStorePath = matchPath(pathName, {
      path: PARAMETERS_STORE_PATH
   })
   const isDistributionRulesPath = matchPath(pathName, {
      path: DISTRIBUTION_RULES_ROUTE_PATH
   })
   const isAgentAllocationsPath = matchPath(pathName, {
      path: AGENT_ALLOCATION_GROUPS_ROUTE_PATH
   })
   const isExecutionLogsPath = matchPath(pathName, {
      path: RD_EXECUTION_LOGS_ROUTE_PATH
   })

   const isAdvancedAnalyticsDashboardsPath = matchPath(pathName, {
      path: ADVANCED_ANALYTICS_DASHBOARDS_ROUTE_PATH
   })

   const isDashboardsPathInPipelineSidebar = matchPath(pathName, {
      path: DASHBOARDS_IN_PIPELINE_SIDEBAR_PATH
   })

   const isGraphsPath = matchPath(pathName, {
      path: '/bar-graphs'
   })

   const isPinnedBoard = matchPath(pathName, {
      path: PINNED_PIPELINE_ITEMS_ROUTE_PATH
   })

   const isCallsBoard = matchPath(pathName, {
      path: CALLS_ROUTE_PATH
   })
   const isHomeBoard = matchPath(pathName, { path: HOME_BOARD_ROUTE_PATH })
   const isAnalyticsCopilotBoard = matchPath(pathName, {
      path: ANALYTICS_COPILOT_PATH
   })

   const isDownloadsPath = matchPath(pathName, {
      path: DOWNLOADS_ROUTE_PATH
   })

   const isActivityLogsPath = matchPath(pathName, {
      path: ACTIVITY_LOGS_ROUTE_PATH
   })

   const isRolesPath = matchPath(pathName, {
      path: ROLES_ROUTE_PATH
   })

   const isUsersPath = matchPath(pathName, {
      path: USERS_ROUTE_PATH
   })

   const isUserGroupsPath = matchPath(pathName, {
      path: USER_GROUPS_ROUTE_PATH
   })

   if (isWorkflowsPath) {
      return ALL_AUTOMATION_WORKFLOWS
   } else if (isParameterStorePath) return PARAMETERS_STORE
   else if (isAnalyticsPath) {
      return ANALYTICS_BUILDER
   } else if (isAllRemindersPath) {
      return ALL_REMINDERS
   } else if (isDistributionRulesPath) {
      return DISTRIBUTION_RULES
   } else if (isAgentAllocationsPath) {
      return AGENT_ALLOCATION_GROUPS
   } else if (isExecutionLogsPath) {
      return EXECUTION_LOGS
   } else if (isContactBoardPath) {
      const matchObj: match<{ boardId: string }> | null = matchPath(pathName, {
         path: CONTACT_BOARD_PATH,
         exact: true
      })

      return matchObj ? matchObj?.params.boardId : null
   } else if (isGraphsPath) {
      return 'GRAPHS'
   } else if (isPinnedBoard) {
      return PINNED
   } else if (isAdvancedAnalyticsDashboardsPath) {
      return ADVANCED_ANALYTICS_DASHBOARDS
   } else if (isDashboardsPathInPipelineSidebar) return DASHBOARDS
   else if (isWorkflowsExecutionLogsPath)
      return AUTOMATION_WORKFLOWS_EXECUTION_LOGS
   else if (isCallsBoard) return CALLS
   else if (isHomeBoard) return HOME_BOARD
   else if (isAnalyticsCopilotBoard) return ANALYTICS_COPILOT
   else if (isDownloadsPath) return DOWNLOADS
   else if (isActivityLogsPath) return ACTIVITY_LOGS
   else if (isRolesPath) return ROLES
   else if (isUsersPath) return USERS
   else if (isUserGroupsPath) return USER_GROUPS
   return null
}

export const getBoardIdFromSPBoards = (pathName: string): string | null => {
   const isAnalyticsPath = matchPath(pathName, {
      path: ANALYTICS_BUILDER_ROUTE_PATH
   })
   if (isAnalyticsPath) {
      return ANALYTICS_BUILDER
   }

   return null
}

export const getBoardIdFromBoardsPath = (pathName: string): string | null => {
   const matchObj: match<{ boardId: string }> | null = matchPath(pathName, {
      path: BOARD_ROUTE_PATH,
      exact: true
   })

   return matchObj ? matchObj?.params.boardId : null
}

export const isFromPipelineDashboards = (pathName: string): boolean => {
   const matchObj: match<{
      pipelineId: string
   }> | null = matchPath(pathName, {
      path: DASHBOARDS_IN_PIPELINE_SIDEBAR_PATH,
      exact: false
   })

   return !!matchObj?.params.pipelineId
}

export const isFromPipelineAnalyticsCopilot = (pathName: string): boolean => {
   const matchObj: match<{
      pipelineId: string
   }> | null = matchPath(pathName, {
      path: ANALYTICS_COPILOT_IN_PIPELINE_SIDEBAR_PATH,
      exact: false
   })

   return !!matchObj?.params.pipelineId
}

export const getGraphIdFromUpdateGraphPath = (
   pathName: string
): string | null => {
   const matchObj: match<{ graphId: string }> | null = matchPath(pathName, {
      path: GRAPH_DETAILED_VIEW_ROUTE_PATH,
      exact: true
   })

   return matchObj ? matchObj?.params.graphId : null
}

export const getGraphIdFromUpdateDashboardGraphPath = (
   pathName: string
): string | null => {
   const matchObj: match<{ graphId: string }> | null = matchPath(pathName, {
      path: DASHBOARD_GRAPH_DETAILED_VIEW_ROUTE_PATH,
      exact: true
   })

   return matchObj ? matchObj?.params.graphId : null
}

export const getDashboardIdFromUpdateGraphPath = (
   pathName: string
): string | null => {
   const matchObj: match<{ dashboardId: string }> | null = matchPath(pathName, {
      path: DASHBOARD_GRAPH_DETAILED_VIEW_ROUTE_PATH,
      exact: true
   })

   return matchObj ? matchObj?.params.dashboardId : null
}

export const getListIdFromListPath = (pathName: string): string | null => {
   const matchObj: match<{ listId: string }> | null = matchPath(pathName, {
      path: LIST_ROUTE_PATH,
      exact: true
   })

   return matchObj ? matchObj?.params.listId : null
}
export const getBoardIdFromListPath = (pathName: string): string | null => {
   const matchObj: match<{ boardId: string }> | null = matchPath(pathName, {
      path: LIST_ROUTE_PATH,
      exact: true
   })

   return matchObj ? matchObj?.params.boardId : null
}
export const navigateToBoard = (
   pipelineId: string,
   boardId: string,
   history: History
): void => {
   const boardPath = `/${SALES_PIPELINE_SUFFIX}/${pipelineId}${BOARD_SUFFIX}/${boardId}`
   history.replace(boardPath)
}

export const navigateToGraph = (
   history: History,
   pipelineId: string,
   graphId: string
): void => {
   const graphPath = `/${SALES_PIPELINE_SUFFIX}/${pipelineId}${GRAPH_SUFFIX}/${graphId}`

   history.push(graphPath)
}

export const navigateToBoardList = (
   pipelineId: string,
   boardId: string,
   listId: string,
   history: History
): void => {
   const boardListPath = `/${SALES_PIPELINE_SUFFIX}/${pipelineId}${BOARD_SUFFIX}/${boardId}/${LIST_SUFFIX}/${listId}`
   history.replace(boardListPath)
}

export const navigateToNoBoardsRoute = (history: History): void => {
   history.replace(NO_BOARDS_ROUTE_PATH)
}

export const navigateToHomeRoute = (history: History): void => {
   history.replace(HOME_ROUTE_PATH)
}

export const navigateToAccessDeniedPage = (history: History) => {
   history.push({ pathname: ACCESS_DENIED_ROUTE_PATH })
}

export const getPipelineIdFromURL = (pathName: string): string | null => {
   const matchObj: match<{ pipelineId: string }> | null = matchPath(pathName, {
      path: [
         `/${SALES_PIPELINE_SUFFIX}/:pipelineId`,
         `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/`,
         `/${PIPELINE_ENTITY}/:pipelineId`
      ],
      exact: false
   })

   return matchObj ? matchObj?.params.pipelineId : null
}

export const getTemplateIdFromURL = (pathName: string): string | null => {
   const matchObj: match<{ templateId: string }> | null = matchPath(pathName, {
      path: [
         `/${TEMPLATES_SUFFIX}/:templateId`,
         `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/`
      ],
      exact: false
   })

   return matchObj ? matchObj?.params.templateId : null
}

export const openWhatsAppUrl = (phoneNumber: string): void => {
   window.open(`https://web.whatsapp.com/send?phone=${phoneNumber}`, '_blank')
}

export const getDealDetailedViewRoutePathAdmin = (
   dealId: string,
   pipelineId: string
): string => `${PIPELINE_ENTITY}/${pipelineId}${DEAL_PREFIX}/${dealId}`

export const getCustomObjectDetailedViewRoutePathAdmin = (
   customObjectId: string,
   pipelineId: string
): string =>
   `${PIPELINE_ENTITY}/${pipelineId}${CUSTOM_OBJECT_PREFIX}/${customObjectId}`

export const getApplicationDetailedViewRoutePathAdmin = (
   applicationId: string,
   pipelineId: string
): string =>
   `${PIPELINE_ENTITY}/${pipelineId}${APPLICATION_PREFIX}/${applicationId}`

export const goToDealDetailedViewRouteAdmin = (
   dealId: string,
   pipelineId: string
): void => {
   const dealDetailedViewPath = getDealDetailedViewRoutePath(dealId, pipelineId)

   window.open(`${Config.AGENT_APP_FRONTEND_BASE_URL}${dealDetailedViewPath}`)
}

export const goToCustomObjectDetailedViewRouteAdmin = (
   customObjectId: string,
   pipelineId: string
): void => {
   const customObjectDetailedViewPath = getCustomObjectDetailedViewRoutePath(
      customObjectId,
      pipelineId
   )

   window.open(
      `${Config.AGENT_APP_FRONTEND_BASE_URL}${customObjectDetailedViewPath}`
   )
}

export const goToApplicationDetailedViewRouteAdmin = (
   applicationId: string,
   pipelineId: string
): void => {
   const applicationDetailedViewPath = getApplicationDetailedViewRoutePath(
      applicationId,
      pipelineId
   )
   window.open(
      `${Config.AGENT_APP_FRONTEND_BASE_URL}${applicationDetailedViewPath}`
   )
}

export const getLeadDetailedViewRoutePathAdmin = (
   leadId: string,
   pipelineId: string
): string => `${PIPELINE_ENTITY}/${pipelineId}${LEAD_PREFIX}/${leadId}`

export const goToLeadDetailedViewRouteAdmin = (
   leadId: string,
   pipelineId: string
): void => {
   const leadDetailedViewPath = getLeadDetailedViewRoutePath(leadId, pipelineId)
   window.open(`${Config.AGENT_APP_FRONTEND_BASE_URL}${leadDetailedViewPath}`)
}

export const goToEntityPipelineDetailedViewRouteAdmin = (
   crmItemType: CRMItemTypeEnum,
   pipelineId: string,
   id: string
) => {
   switch (crmItemType) {
      case CRMItemTypeEnum.Lead:
         goToLeadDetailedViewRouteAdmin(id, pipelineId)
         break
      case CRMItemTypeEnum.Deal:
         goToDealDetailedViewRouteAdmin(id, pipelineId)
         break
      case CRMItemTypeEnum.CustomObject:
         goToCustomObjectDetailedViewRouteAdmin(id, pipelineId)
         break
      case CRMItemTypeEnum.Application:
         goToApplicationDetailedViewRouteAdmin(id, pipelineId)
         break
      default:
         break
   }
}

export const getDealDetailedViewRoutePath = (
   dealId: string,
   pipelineId: string
): string => `${PIPELINE_ENTITY}/${pipelineId}${DEAL_PREFIX}/${dealId}`

export const getCustomObjectDetailedViewRoutePath = (
   customObjectId: string,
   pipelineId: string
): string =>
   `${PIPELINE_ENTITY}/${pipelineId}${CUSTOM_OBJECT_PREFIX}/${customObjectId}`

export const getApplicationDetailedViewRoutePath = (
   applicationId: string,
   pipelineId: string
): string =>
   `${PIPELINE_ENTITY}/${pipelineId}${APPLICATION_PREFIX}/${applicationId}`

export const goToDealDetailedViewRoute = (
   dealId: string,
   pipelineId: string
): void => {
   const dealDetailedViewPath = getDealDetailedViewRoutePath(dealId, pipelineId)

   window.open(`/${dealDetailedViewPath}`)
}

export const goToCustomObjectDetailedViewRoute = (
   customObjectId: string,
   pipelineId: string
): void => {
   const customObjectDetailedViewPath = getCustomObjectDetailedViewRoutePath(
      customObjectId,
      pipelineId
   )

   window.open(`/${customObjectDetailedViewPath}`)
}

export const goToApplicationDetailedViewRoute = (
   applicationId: string,
   pipelineId: string
): void => {
   const applicationDetailedViewPath = getApplicationDetailedViewRoutePath(
      applicationId,
      pipelineId
   )
   window.open(`/${applicationDetailedViewPath}`)
}

export const getLeadDetailedViewRoutePath = (
   leadId: string,
   pipelineId: string
): string => `${PIPELINE_ENTITY}/${pipelineId}${LEAD_PREFIX}/${leadId}`

export const goToLeadDetailedViewRoute = (
   leadId: string,
   pipelineId: string
): void => {
   const leadDetailedViewPath = getLeadDetailedViewRoutePath(leadId, pipelineId)
   window.open(`/${leadDetailedViewPath}`)
}

export const goToEntityPipelineDetailedViewRoute = (
   crmItemType: CRMItemTypeEnum,
   pipelineId: string,
   id: string
): void => {
   switch (crmItemType) {
      case CRMItemTypeEnum.Lead:
         goToLeadDetailedViewRoute(id, pipelineId)
         break
      case CRMItemTypeEnum.Deal:
         goToDealDetailedViewRoute(id, pipelineId)
         break
      case CRMItemTypeEnum.CustomObject:
         goToCustomObjectDetailedViewRoute(id, pipelineId)
         break
      case CRMItemTypeEnum.Application:
         goToApplicationDetailedViewRoute(id, pipelineId)
         break
      default:
         break
   }
}

export const navigateToPipelineItemDetailedViewRoute = (
   crmItemType: CRMItemTypeEnum,
   pipelineId: string,
   pipelineItemId: string,
   history: History
): void => {
   switch (crmItemType) {
      case CRMItemTypeEnum.Lead: {
         const url = `/${getLeadDetailedViewRoutePath(
            pipelineItemId,
            pipelineId
         )}`
         history.push(url)
         break
      }
      case CRMItemTypeEnum.Deal: {
         const url = `/${getDealDetailedViewRoutePath(
            pipelineItemId,
            pipelineId
         )}`
         history.push(url)
         break
      }
      case CRMItemTypeEnum.CustomObject: {
         const url = `/${getCustomObjectDetailedViewRoutePath(
            pipelineItemId,
            pipelineId
         )}`
         history.push(url)
         break
      }
      case CRMItemTypeEnum.Application: {
         const url = `/${getApplicationDetailedViewRoutePath(
            pipelineItemId,
            pipelineId
         )}`
         history.push(url)
         break
      }
      default:
         break
   }
}

export const goToRecordDetailedViewRoute = (recordId: string): void => {
   const url = `${RECORD_PREFIX}/${recordId}`
   window.open(url)
}

export const goToHome = (history: History): void => {
   history.push(HOME_ROUTE_PATH)
}

export const goToAdvancedAnalyticsDashboards = (
   history: History,
   pipelineId: string | null,
   isOfficerPortal?: boolean
): void => {
   const adminPrefix = isOfficerPortal ? '' : `/${ADMIN_ROUTE_SUFFIX}`

   pipelineId
      ? history.push(
           `${adminPrefix}/${SALES_PIPELINE_SUFFIX}/${pipelineId}${BOARD_SUFFIX}${ADVANCED_ANALYTICS_DASHBOARDS_ROUTE_PATH}`
        )
      : history.push(
           `${adminPrefix}${ADVANCED_ANALYTICS_DASHBOARDS_ROUTE_PATH}`
        )
}

export const goToAnalyticsDashboard = (
   history: History,
   dashboardId: string,
   pipelineId: string | null,
   isOfficerPortal?: boolean
): void => {
   const adminPrefix = isOfficerPortal ? '' : `/${ADMIN_ROUTE_SUFFIX}`

   pipelineId
      ? history.push(
           `${adminPrefix}/${SALES_PIPELINE_SUFFIX}/${pipelineId}${BOARD_SUFFIX}${DASHBOARDS_PATH}/${dashboardId}`
        )
      : history.push(
           `${adminPrefix}${ADVANCED_ANALYTICS_DASHBOARDS_ROUTE_PATH}/${dashboardId}`
        )
}

export const goToAnalyticsBuilder = (
   history: History,
   pipelineId: string | null
): void => {
   history.push(
      `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/${pipelineId}/${ANALYTICS_BUILDER_ENTITY}`
   )
}
export const goToObjectAdminAnalyticsBuilder = (
   history: History,
   templateId: string
): void => {
   history.push(
      `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/${templateId}/${ANALYTICS_BUILDER_ENTITY}`
   )
}
export const goToGraphDetailedView = (
   history: History,
   pipelineId: string | null,
   graphId: string
): void => {
   history.push(
      `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/${pipelineId}/${ANALYTICS_BUILDER_ENTITY}${GRAPH_SUFFIX}/${graphId}`
   )
}

export const goToObjectAdminGraphDetailedView = (
   history: History,
   templateId: string,
   pipelineId: string | null,
   graphId: string
): void => {
   history.push(
      `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/${templateId}/${ANALYTICS_BUILDER_ENTITY}/${SALES_PIPELINE_SUFFIX}/${pipelineId}${GRAPH_SUFFIX}/${graphId}`
   )
}

export const goToAWExecLogDetailedViewRoute = (
   history: History,
   awExecLogId: string,
   pipelineId: string
): void => {
   const url = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/${pipelineId}/${AW_EXECUTION_LOGS_SUFFIX}/${awExecLogId}`
   history.push(url)
}

export const goToObjectAdminAWExecLogDetailedViewRoute = (
   history: History,
   awExecLogId: string,
   templateId: string,
   pipelineId: string
): void => {
   const url = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/${templateId}/${AW_EXECUTION_LOGS_SUFFIX}/${SALES_PIPELINE_SUFFIX}/${pipelineId}/${awExecLogId}`
   history.push(url)
}

export const goToAutomationWorkflowsExecutionLogs = (
   history: History,
   pipelineId: string
): void => {
   const url = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/${pipelineId}/${AW_EXECUTION_LOGS_SUFFIX}`

   history.push(url)
}

export const goToObjectAdminAutomationWorkflowsExecutionLogs = (
   history: History,
   templateId: string
): void => {
   const url = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/${templateId}/${AW_EXECUTION_LOGS_SUFFIX}`

   history.push(url)
}

export const goToAdminRoute = (history: History): void => {
   history.push(ADMIN_ROUTE_PATH)
}

export const goToPluginAccountDetailsRoute = (
   history: History,
   pluginId: string
): void => {
   const url = `${KNOWLARITY_PLUGIN_ACCOUNTS_ROUTE_PATH}/${pluginId}`
   history.push(url)
}

export const goToPluginsRoute = (history: History): void => {
   history.push(PLUGINS_ROUTE_PATH)
}

export const goToPluginAccountDetailedViewRoute = (
   history: History,
   pluginId: string,
   pluginServiceAccountId: string
): void => {
   const url = `${KNOWLARITY_PLUGIN_ACCOUNTS_ROUTE_PATH}/${pluginId}/${PLUGIN_ACCOUNT_DETAILED_VIEW_SUFFIX}/${pluginServiceAccountId}`
   history.push(url)
}

export const goToSmartfloAccountsRoute = (
   history: History,
   pluginId: string
): void => {
   const url = `${SMARTFLO_PLUGIN_ACCOUNTS_ROUTE_PATH}/${pluginId}`
   history.push(url)
}

export const goToSmartfloPluginAccountDetailedViewRoute = (
   history: History,
   pluginId: string,
   pluginServiceAccountId: string
): void => {
   const url = `${SMARTFLO_PLUGIN_ACCOUNTS_ROUTE_PATH}/${pluginId}/${PLUGIN_ACCOUNT_DETAILED_VIEW_SUFFIX}/${pluginServiceAccountId}`
   history.push(url)
}

export const openHomeRouteInNewTab = (): void => {
   openLinkInNewTab(HOME_ROUTE_PATH)
}

export const openDownloadsRouteInNewTab = (pipelineId: string): void => {
   const url = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/${pipelineId}/${DOWNLOADS_SUFFIX}`
   openLinkInNewTab(url)
}

export const goToPipelineSettings = (
   history: History,
   pipelineId: string
): void => {
   const url = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/${pipelineId}/${PIPELINE_SETTINGS_PATH}`
   history.push(url)
}

export const goToTemplatePipelineSettings = (
   history: History,
   templateId: string
): void => {
   const url = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/${templateId}/${ADMIN_TEMPLATE_PIPELINES_ROUTE_SUFFIX}`
   history.push(url)
}

export const navigateToAgentSchedulesRoute = (agentId: string): void => {
   const url = `/${AGENT_SCHEDULES_PATH_SUFFIX}/${agentId}`
   window.open(url)
}

export const goToDocumentTemplatesRoute = (
   history: History,
   pipelineId: string
): void => {
   const adminPipelineSuffix = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}`
   const url = `${adminPipelineSuffix}/${pipelineId}/${DOCUMENT_TEMPLATES_ROUTE_SUFFIX}`
   history.push(url)
}

export const goToObjectAdminDocumentTemplatesRoute = (
   history: History,
   templateId: string
): void => {
   const adminPipelineSuffix = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}`
   const url = `${adminPipelineSuffix}/${templateId}/${DOCUMENT_TEMPLATES_ROUTE_SUFFIX}`
   history.push(url)
}

export const goToDocumentTemplateDetailedViewRoute = (
   history: History,
   pipelineId: string,
   documentTemplateVersionId: string
): void => {
   const adminPipelineSuffix = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}`
   const url = `${adminPipelineSuffix}/${pipelineId}/${DOCUMENT_TEMPLATES_ROUTE_SUFFIX}/${documentTemplateVersionId}`
   history.push(url)
}

export const goToTemplateAdminDocumentTemplateDetailedViewRoute = (
   history: History,
   templateId: string,
   documentTemplateVersionId: string
): void => {
   const adminPipelineSuffix = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}`
   const url = `${adminPipelineSuffix}/${templateId}/${DOCUMENT_TEMPLATES_ROUTE_SUFFIX}/${documentTemplateVersionId}`
   history.push(url)
}

export const navigateToPipelineBoard = (
   history: History,
   pipelineId: string,
   boardId: string
): void => {
   const boardPath = `/${SALES_PIPELINE_SUFFIX}/${pipelineId}${BOARD_SUFFIX}/${boardId}`
   history.push(boardPath)
}

export const navigatePipelineItemScoringLogs = (
   history: History,
   pipelineId: string
): void => {
   const url = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/${pipelineId}/${SCORING_RECALCULATION_LOGS_ROUTE_SUFFIX}`
   history.push(url)
}

export const navigateToObjectPipelineItemScoringLogs = (
   history: History,
   templateId: string
): void => {
   const path = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/${templateId}/${SCORING_RECALCULATION_LOGS_ROUTE_SUFFIX}`

   history.push(path)
}

export const openCRMItemDetailedViewInNewTab = (
   applicationId: string,
   pipelineId: string
): void => {
   const crmItemDetailedViewUrl = `${PIPELINE_ENTITY}/${pipelineId}${APPLICATION_PREFIX}/${applicationId}`
   openLinkInNewTab(crmItemDetailedViewUrl)
}
export const openLegacyApplicationDetailedViewInNewTab = (
   applicationId: string
): void => {
   const LegacyApplicationDetailedViewUrl = `${Config.FRONTEND_BASE_URL}${LEGACY_APPLICATIONS_SUFFIX}?${LEGACY_APPLICATION_DETAILED_VIEW_SUFFIX}=${applicationId}`
   openLinkInNewTab(LegacyApplicationDetailedViewUrl)
}

export const redirectToDigitalizationPortalUrl = (
   username: string,
   pipelineId: string
): void => {
   const accessToken = Cookies.get('access_token')
   const refreshToken = Cookies.get('refresh_token')

   window.open(
      `${Config.DIGITALIZATION_PORTAL_URL}?at=${accessToken}&rt=${refreshToken}&un=${username}&pid=${pipelineId}`,
      '_blank'
   )
}
